// TODO: Remove, stand alone snapshots dead
export default props => {
  return false;
};
